module.exports = new __parcel__URL__("now-add-your-team.9826b1af.svg").toString();